<template>
    <div>
        <div v-if="isLoadingStuff" class="text-center p-3">
            <loader></loader>
        </div>

        <div v-else>
            <h3 class="mt-3">Product Pricing</h3>

            <!-- Disabled old form to test PricingManager -->
            <div v-if="false">
                <div class="row my-5 align-items-center">
                    <div class="col-sm-4 pt-3">
                        <checkbox name="priceIncludeTaxes" class="" v-model="getSelectedEvent.isPriceIncludeTaxes">Price include taxes</checkbox>
                    </div>
                </div>

                <div class="row mb-4">
                    <div class="col-sm-4">
                        <v-select
                            v-if="types"
                            v-model="selectedPrincingType"
                            :options="types"
                            label="description"
                            placeholder="- Select type -"
                            @input="updateType(selectedPrincingType)">
                        </v-select>
                    </div>

                    <div class="col-sm-8" v-if="selectedPrincingType && selectedPrincingType.id == 1">
                        <div class="row">
                            <div class="col-sm-4">
                                <v-select
                                    v-if="taxes"
                                    v-model="getSelectedEvent.eventGenderPrices[0].vatTypeHelper"
                                    :options="taxes"
                                    label="description"
                                    placeholder="- Select tax -"
                                    @input="updateTaxType(getSelectedEvent.eventGenderPrices[0], getSelectedEvent.eventGenderPrices[0].vatTypeHelper)">
                                </v-select>
                            </div>

                            <div class="col-sm-4">
                                <div class="d-flex">
                                    <input class="glued-right" type="number" v-model="getSelectedEvent.eventGenderPrices[0].value" style="width: 4rem;">
                                    <div class="glued-left">€</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="w-100" v-if="selectedPrincingType && selectedPrincingType.id == 2">

                    <div class="row" v-if="getSelectedEvent.eventGenderPrices && getSelectedEvent.eventGenderPrices.length > 0">
                        <div class="col-sm-3">
                            <label class="full">Age group</label>
                        </div>
                        <div class="col-sm-3">
                            <label class="full">Tax</label>
                        </div>
                        <div class="col-sm-2">
                            <label class="full">Total</label>
                        </div>
                        <div class="col-sm-2">
                        </div>
                    </div>

                    <div class="col-sm-12 mt-2 bg-lighter border-light radius-normal py-2 overflow-hide" v-for="pricePerPerson, index in getSelectedEvent.eventGenderPrices">
                        <div class="row">
                            <div class="col-sm-3" v-if="getSelectedEvent.eventGenderPrices">
                                <v-select
                                    class="w-100"
                                    v-if="audienceTypes"
                                    v-model="pricePerPerson.audienceTypeHelper"
                                    :options="audienceTypes"
                                    label="description"
                                    placeholder="- Select type -"
                                    @input="updateAudienceType(pricePerPerson, pricePerPerson.audienceTypeHelper)">
                                </v-select>
                            </div>

                            <div class="col-sm-3">
                                <input type="text" disabled="disabled" :value="customPerPersonTaxes(pricePerPerson.productGenderPriceComponents)" class="w-100" v-if="pricePerPerson.productGenderPriceComponents && pricePerPerson.productGenderPriceComponents.length > 0"></input>
                                <v-select
                                    v-if="taxes && pricePerPerson.productGenderPriceComponents && pricePerPerson.productGenderPriceComponents.length <= 0"
                                    v-model="pricePerPerson.vatTypeHelper"
                                    :options="taxes"
                                    label="description"
                                    placeholder="- Select tax -"
                                    @input="updateTaxType(pricePerPerson, pricePerPerson.vatTypeHelper)">
                                </v-select>
                            </div>

                            <div class="col-sm-2 px-0">
                                <input type="text" disabled="disabled" :value="customPerPersonTotal(pricePerPerson.productGenderPriceComponents)+' €'" class="w-100" v-if="pricePerPerson.productGenderPriceComponents && pricePerPerson.productGenderPriceComponents.length > 0"></input>
                                <div class="d-flex w-100" v-else>
                                    <input class="glued-right w-100" type="number" style="width: 4rem;" v-model="pricePerPerson.value">
                                    <div class="glued-left">€</div>
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="color-1 fs-small mt-2 pointer" @click="openEditPrice(pricePerPerson)"><i class="ico" :class="{'ico-arrow-bottom':!pricePerPerson.editing, 'ico-arrow-top':pricePerPerson.editing}"></i> Edit price</div>
                            </div>

                            <div class="col-sm-1" v-if="index > 0">
                                <div class="mt-2">
                                    <i class="ico-delete fs-large medium pointer" @click="removePrincingAgeRow(index)"></i>
                                </div>
                            </div>

                            <div class="w-100 px-2 mx-2 py-3 w-100 mt-3 d-flex flex-column bg-lightest radius-normal border-light" v-if="pricePerPerson.editing">

                                <split-price-editor :priceObj="pricePerPerson"></split-price-editor>

                            </div>
                        </div>

                    </div>


                    <div class="row mt-3">
                        <div class="col-sm-12">
                            <div class="add d-flex align-items-center pointer fs-small bold" @click="addRow">
                                <i class="ico-add fs-smallest add-circle color-1"></i> Add new price
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <pricingManager v-else :showHeader="false" v-model="getSelectedEvent.eventGenderPrices" />
      </div>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import SplitPriceEditor from '../../../components/inventory/products/SplitPriceEditor'
    import Loader from '@/tools/loaders/loader1'

    import PricingManager from '@/components/inventory/products/components/PricingManager'

    export default {
        data: function() {
            return {
                selectedPrincingType: null,
                isLoadingTypes: false,
                isLoadingTaxes: false,
                isLoadingAudienceTypes: false,
                runUpdateTypeCounter: 0
            }
        },
        props: {
            validations: {
                type: Object
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedEvent',
                'getIsCreatSingleEvent',
                'getVatTypes'
            ]),
            taxes: function () {
                return this.getVatTypes
            },
            // pricesArrTweaked: function(){
            //     let output = this.getSelectedEvent.product.prices;
            //     for (let price of output) {
            //         // when coming form the API if a price is "per order" insetad of "per person"
            //         // the price has the description of "" that messes with the dropdow,
            //         // so this changes "" to " "
            //         if(price.description == ""){
            //             price.description = " ";
            //         }
            //
            //     }
            //     return output;
            // },
            isLoadingStuff: function() {
                // return this.isLoadingTypes || this.isLoadingTaxes || this.isLoadingAudienceTypes
                return false //disables loader
            }
        },
        created: function() {
            // console.log('selectedPrincingType', selectedPrincingType);
            if(!this.getSelectedEvent.eventGenderPrices || this.getSelectedEvent.eventGenderPrices.length == 0){
                this.updateType({id:1}) // adds a pricing row of eventGenderPrices is empty
            }

            //this fixes the problem that if for some reason the event ends up without prices
            if(this.getSelectedEvent.eventGenderPrices.length == 0){
                this.getSelectedEvent.eventGenderPrices = [
                    {
                        genderPriceType: 1,
                        vatType: 0,
                        value: 0,
                        currency: "€"
                    }
                ]
            }

            // VAT
            if(this.getSelectedEvent.eventGenderPrices){
                for (let pricingRow of this.getSelectedEvent.eventGenderPrices) {
                    //if(pricingRow.genderPriceType == 2){
                        pricingRow.vatTypeHelper = this.taxes.filter((audienceType) => {
                            return audienceType.id == pricingRow.vatType;
                        })[0]
                    //}
                }
            }
        },
        asyncComputed: {
            async types() {
                try {
                    this.isLoadingTypes = true
                    let response = await axios.get('/api/settings/GetComponentExtraPriceTypeList');
                    this.isLoadingTypes = false

                    if (response && response.status === 200 && response.data && response.data.length > 0) {

                        // set the pricing dropdow to "Per order" or "Per Person"
                        // console.log(this.getSelectedEvent.eventGenderPrices);
                        try {
                            if(this.getSelectedEvent.eventGenderPrices.length == 0){
                                this.selectedPrincingType = response.data[0];
                            } else {
                                if(this.getSelectedEvent.eventGenderPrices[0].genderPriceType == 1){
                                    this.selectedPrincingType = response.data[0];
                                } else {
                                    this.selectedPrincingType = response.data[1];
                                }
                            }

                        } catch (e) {

                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            },
            async audienceTypes() {
                try {
                    this.isLoadingAudienceTypes = true
                    let response = await axios.get('/api/settings/GetAudienceTypeList');
                    this.isLoadingAudienceTypes = false

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Map FK information through selects

                        if(this.getSelectedEvent.eventGenderPrices){
                            for (let pricingRow of this.getSelectedEvent.eventGenderPrices) {
                                if(pricingRow.genderPriceType == 2){
                                    pricingRow.audienceTypeHelper = response.data.filter((audienceType) => {
                                        return audienceType.id == pricingRow.audienceType;
                                    })[0]
                                }
                            }
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            },
        },
        methods:{
            ...mapActions([
                'openModal',
                'updateroductEditPriceData'
            ]),
            updateType: function(selectedType){
                // console.log('running updateType', selectedType);
                if(this.runUpdateTypeCounter > 0 || this.getIsCreatSingleEvent){
                    if(selectedType.id == 1){
                        if(!this.getSelectedEvent.eventGenderPrices || this.getSelectedEvent.eventGenderPrices.length == 0 || this.getSelectedEvent.eventGenderPrices === undefined || this.getSelectedEvent.eventGenderPrices[0].genderPriceType != 1){
                            // console.log('setting princing to one row Per Order');
                            this.getSelectedEvent.eventGenderPrices = [
                                {
                                    genderPriceType: 1,
                                    vatType: 0,
                                    value: 0,
                                    currency: "€"
                                }
                            ]
                        }
                    } else {
                        // console.log('setting princing to one row Per Person', this.getSelectedEvent.eventGenderPrices.genderPriceType);
                        // console.log('-- start debug --');
                        // console.log('this.audienceTypes', this.audienceTypes);
                        // console.log('this.taxes', this.taxes);
                        // console.log('this.getSelectedEvent.eventGenderPrices.genderPriceType', this.getSelectedEvent.eventGenderPrices.genderPriceType);
                        // console.log('-- end debug --');
                        // console.log('this.getSelectedEvent.eventGenderPrices[0].productGenderPriceComponents',this.getSelectedEvent.eventGenderPrices[0].productGenderPriceComponents);
                        // console.log('this.getSelectedEvent.eventGenderPrices',this.getSelectedEvent.eventGenderPrices);
                        // console.log('-- end debug --');

                        if(this.audienceTypes && this.taxes && !this.getSelectedEvent.eventGenderPrices.genderPriceType && (this.getSelectedEvent.eventGenderPrices && this.getSelectedEvent.eventGenderPrices[0].genderPriceType != 2)){
                            this.$set(this.getSelectedEvent, 'eventGenderPrices', [
                                {
                                    genderPriceType: 2,
                                    audienceType: this.audienceTypes[0].id,
                                    audienceTypeHelper: this.audienceTypes[0],
                                    value: 0,
                                    currency: '€',
                                    vatType: this.taxes[0].id,
                                    vatTypeHelper: this.taxes[0],
                                    productGenderPriceComponents: [
                                    ]
                                }
                            ])
                        }
                    }
                } else {
                    // console.log('updateType blocked by counter');
                }

                this.runUpdateTypeCounter++ //hacky way of prevent the first run of updateType that is triggered on created
            },
            updateAudienceType: function(row, selectedAudienceType){
                row.audienceType = selectedAudienceType.id;
            },
            customPerPersonTaxes: function(row) {
                let taxes = [];
                for (let service of row) {
                    // if(taxes.indexOf(service.component.vatType+'%') == -1){
                    //     taxes.push(service.component.vatType+'%')
                    // }
                    if(service.component.selectedPrice && taxes.indexOf(service.component.selectedPrice.vatType+'%') == -1){
                        taxes.push(service.component.selectedPrice.vatType+'%')
                    }
                }
                return taxes.join(', ')
            },
            updateTaxType: function(row, selectedVatType){
                row.vatType = selectedVatType.id;
            },
            customPerPersonTotal: function(row) {
                let total = 0;
                for (let service of row) {
                    // total += service.component.priceTotal
                    if(service.component.selectedPrice){
                        total += service.component.selectedPrice.grossprice
                    }
                }
                return (total).toFixed(2).replace(".", ",");
            },
            openEditPrice: function(priceRow) {
                if(!priceRow.editing){
                    this.$set(priceRow, 'editing', true);
                } else {
                    this.$set(priceRow, 'editing', false);
                }
                this.updateroductEditPriceData(priceRow)
                // this.openModal('ProductEditPrice');
            },
            removePrincingAgeRow: function(index) {
                this.getSelectedEvent.eventGenderPrices.splice(index, 1);
            },
            addRow: function() {
                // console.log('clicked add row');
                let defaultRow = {
                    genderPriceType: 2,
                    audienceType: this.audienceTypes[0].id,
                    audienceTypeHelper: this.audienceTypes[0],
                    value: 0,
                    currency: '€',
                    vatType: this.taxes[0].id,
                    vatTypeHelper: this.taxes[0],
                    isTaxIncludedInPrice: this.getSelectedEvent.isPriceIncludeTaxes,
                    productGenderPriceComponents: [
                    ]
                }

                this.getSelectedEvent.eventGenderPrices.push(defaultRow)
                this.$forceUpdate();
            },
        },
        components: {
            vSelect: extendedVSelect,
            SplitPriceEditor,
            Loader,
            PricingManager
        }
    }
</script>

<style lang="scss" scoped>
    // .app .v-select{
    //     display: inline-flex;
    // }
</style>



// WEBPACK FOOTER //
// areaPrices.vue?66be58a2